import { IDialogAction } from './IDialogAction';
import { DialogSignalRService } from '../services/DialogSignalRService';
import { Store } from 'redux';
import { DialogState } from '../models/DialogState';

export const ADD_LIKE = 'ADD_LIKE';

export class AddLikeAction implements IDialogAction {
    public readonly type = ADD_LIKE;
    public constructor(public payload: any, private _service?: DialogSignalRService) {}
    public middleware(store: Store): any {
        if(this._service) {
            this._service.addLike(this.payload.ids, true);
        }
        return;
    }
    public reducer(state: any): any {
        return state;
    }
}